import { render, staticRenderFns } from "./couponDetails.vue?vue&type=template&id=6a5a66bb&scoped=true"
import script from "./couponDetails.vue?vue&type=script&lang=js"
export * from "./couponDetails.vue?vue&type=script&lang=js"
import style0 from "./couponDetails.vue?vue&type=style&index=0&id=6a5a66bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5a66bb",
  null
  
)

export default component.exports